<template>
<div class="chapter">
<div class="inner_page">
<h2 class="BHD">EQUIPMENT</h2>
<p class="INTRO1">To create great cakes you need the right equipment, and we've gathered together the tools of our trade here. You won't need everything pictured below, but use our advice in the flower instructions and cake projects in this book to select the items that you need to get the best results.</p>
<div class="IMAGE">
<p class="image-left"><img alt="" src="images/C1-F3.jpg"/></p>
<p class="IMG-ANNO"><b>1</b> Cake leveller</p>
<p class="IMG-ANNO"><b>2</b> Serrated/straight knives</p>
<p class="IMG-ANNO"><b>3</b> Sieve (sifter/strainer)</p>
<p class="IMG-ANNO"><b>4</b> Scissors</p>
<p class="IMG-ANNO"><b>5</b> Ruler</p>
<p class="IMG-ANNO"><b>6</b> Spatulas</p>
<p class="IMG-ANNO"><b>7</b> Cake turntable</p>
<p class="IMG-ANNO"><b>8</b> Greaseproof (wax) paper and cling film</p>
<p class="IMG-ANNO"><b>9</b> Measuring cups/spoons</p>
<p class="IMG-ANNO"><b>10</b> Couplers</p>
<p class="IMG-ANNO"><b>11</b> Disposable piping (pastry) bags</p>
<p class="IMG-ANNO"><b>12</b> Palette knife</p>
<p class="IMG-ANNO"><b>13</b> Flower nail</p>
<p class="IMG-ANNO"><b>14</b> Cake scraper</p>
<p class="IMG-ANNO"><b>15</b> Mixing bowls</p>
<p class="IMG-ANNO"><b>16</b> Tweezers</p>
<p class="IMG-ANNO"><b>17</b> Nozzles</p>
<p class="IMG-ANNO"><b>18</b> Food colouring pastes and gels</p>
<p class="IMG-ANNO"><b>19</b> Weighing scales</p>
<p class="IMG-ANNO"><b>20</b> Hand-held mixer</p>
<p class="IMG-ANNO"><b>21</b> Stand mixer</p>
<p class="IMG-ANNO"><b>22</b> Cupcake tin</p>
<p class="IMG-ANNO"><b>23</b> Airbrush machine</p>
<p class="IMG-ANNO"><b>24</b> Cupcake liners</p>
<p class="IMG-ANNO"><b>25</b> Tall glass</p>
<p class="IMG-ANNO"><b>26</b> Gold dragees</p>
<p class="IMG-ANNO"><b>27</b> Cocktail sticks</p>
<p class="IMG-ANNO"><b>28</b> Cake boards and cards</p>
<p class="IMG-ANNO"><b>29</b> Interfacing cloth</p>
<p class="IMG-ANNO"><b>30</b> Headed pins</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter12.vue?4e403d1e